export default "__VITE_ASSET__ZfzbR1N8__"